
























































import Vue, {VueConstructor} from 'vue'
import _ from 'lodash'
import {Dictionary} from 'vuex'
import UiTable from '../Table/Table.vue'
import UiFiltersAndActions from '../FiltersAndActions/FiltersAndActions.vue'
import {ActiveTableConfig} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import UiPagination from '@/components/Ui/Pagination/Pagination.vue'
import {SelectValue} from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'
import {TableColOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'
import IndexColumn from '@/components/Ui/ActiveTable/IndexColumn.vue'
import ActionsDropdown from '@/components/Ui/ActiveTable/ActionsDropdown.vue'
import {TableRowClickEvent} from '@/components/Ui/Table/BZCore/Table'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    filters: {
      filtersData: any
      searchData: any
    }
  }
}>).extend({
  name: 'ActiveTable',
  components: {UiTable, UiFiltersAndActions, UiPagination, ActionsDropdown},
  props: {
    config: Object as () => ActiveTableConfig,
    hiddenFilters: {
      type: Boolean,
      default: false
    },
    defaultFilters: {type: Object as () => Dictionary<any>, default: () => {}},
    defaultSort: Object as () => Dictionary<1 | -1>,
    selectable: Boolean,
    rowKey: String,
    defaultCheckedKeys: {type: Array as () => string[], default: () => []},
    hideFiltersFooter: Boolean,
    hideFiltersBody: Boolean,
    hideEmptyTable: Boolean,
    scope: {
      type: Object as () => any,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      loadedData: [] as any[],
      selectedColumns: [] as string[],
      currentSort: {} as Dictionary<1 | -1>,
      pagination: {
        pageSize: this.config.defaultPageSize || 10,
        currentPage: 1,
        totalItems: 1000
      },
    }
  },
  created () {
    if (this.config.defaultShownColumns) {
      this.selectedColumns = this.config.defaultShownColumns
    } else {
      this.selectedColumns = Object.keys(this.config.table.cols)
    }
  },
  async mounted () {
    await this.setDefaultSort()
    this.loadList()
  },
  methods: {
    setDefaultSort () {
      if (this.defaultSort) {
        this.currentSort = this.defaultSort
      }
    },
    onToggleSort (collName: string) {
      if (!this.currentSort.hasOwnProperty(collName)) {
        this.$set(this.currentSort, collName, -1)
      } else if (this.currentSort[collName] === -1) {
        this.$set(this.currentSort, collName, 1)
      } else {
        this.$delete(this.currentSort, collName)
      }
      this.pagination.currentPage = 1
      this.$emit('onSortChanged', this.currentSort)
      this.loadList()
    },
    onRowClick (event: TableRowClickEvent) {
      if (this.config.onRowClick) {
        this.config.onRowClick(event)
      }
      this.$emit('rowClick', event)
    },
    onColumnSelection (event: string[]) {
      this.selectedColumns = event
    },
    onPaginationPageSizeChange (pageSize: number) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = pageSize;
      this.loadList()
    },
    onSearchChanged () {
      this.pagination.currentPage = 1;
      this.loadList()
    },
    onFiltersChanged (filters: Dictionary<any>) {
      this.pagination.currentPage = 1;
      this.$emit('onFiltersChanged', filters)
      this.loadList()
    },
    onPaginationCurrentChange (currentPage: number) {
      this.pagination.currentPage = currentPage
      this.loadList()
    },
    onRowChecked (checkedRows: any) {
      this.$emit('onRowChecked', checkedRows)
    },
    loadList: _.debounce(async function () {
      // @ts-ignore
      const search = this.$refs.filters.searchData
      // @ts-ignore
      const filters = this.$refs.filters.filtersData
      // @ts-ignore
      const offset = this.pagination.pageSize * this.pagination.currentPage - this.pagination.pageSize
      // @ts-ignore
      const result = (await this.config.find(search, filters, this.currentSort, this.pagination.pageSize, offset, this.scope))
      // @ts-ignore
      this.loadedData = result.list
      // @ts-ignore
      this.pagination.totalItems = result.count
    }, 500)
  },
  computed: {
    documentsName (): string {
      // @ts-ignore
      return this.config.documentsName || this.$t('labels.records')
    },
    columnSelector (): SelectValue[] {
      const cols = []
      for (const fieldName in this.config.table.cols) {
        cols.push({
          label: this.config.table.cols[fieldName].label,
          value: fieldName
        })
      }
      return cols
    },
    shownColumns (): any {
      const cols: Dictionary<TableColOptions> = {
        _tableindex: {label: '№', component: this.config.indexColumnComponent || IndexColumn}
      }
      for (const fieldName in this.config.table.cols) {
        if (this.selectedColumns.indexOf(fieldName) !== -1) {
          cols[fieldName] = this.config.table.cols[fieldName]
        }
      }
      if (this.config.actions) {
        // @ts-ignore
        cols._actions = {label: this.$t('labels.actions')}
      }
      return cols
    },
    tableVissible (): boolean {
      if (this.hideEmptyTable) {
        return !!this.loadedData.length
      } else {
        return true;
      }
    }
  }
})
